<template>
  <div>
    <w-checkbox
      v-for="(option, index) in filter.options"
      :key="'option_' + index"
      :model="schema.$in"
      :value="option.value"
      :title="option.text"
      @input="$emit('update')"
    />
  </div>
</template>

<script>
import { components } from '@witkac/bootstrap4-components';

// @vuese
// Formularz przedziału liczb
export default {
  components,
  props: {
    // schema
    schema: { type: Object, required: true },
    // filtr
    filter: { type: Object, required: true },
    // tytuł pola
    title: { type: String, required: true }
  }
};
</script>
